//export const baseUrl = process.env.NODE_ENV === 'development' ?  'https://contactmate.fi/a/t/v2/public/index.php' : 'https://contactmate.fi/a/v2/public/index.php'
export const baseUrl = 'https://contactmate.fi/a/t/v2/public/index.php'